import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import * as feather from 'feather-icons';
import { RouterService } from './shared/services/router.service';
import { Subscription } from 'rxjs';
import { SharedService } from './shared/shared.service';
import { WebsocketService } from './shared/services/websocket.service';
import { AuthService } from './shared/services/auth.service';
import { environment } from 'src/environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit, AfterViewInit {
  // ──────────────────────────────────────────────────────────────
  private readonly DEEP_LINK_SCHEME = 'myapp://'; // Base scheme for iOS and Android
  private readonly PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=ems.portal';
  private readonly APP_STORE_URL = 'https://apps.apple.com/in/app/emsconnect/id6751587112';
  private readonly DESKTOP_REDIRECT = '/invoices/all-invoice';
  // ──────────────────────────────────────────────────────────────

  showLoader = false;
  showLoader1 = false;
  loaderSubscription!: Subscription;
  loaderSubscription1!: Subscription;
  websocketSubscription!: Subscription;
  messages: string[] = [];
  serverUrl: string = '';
  authToken: any;
  deviceInfo: any;

  constructor(
    private _route: Router,
    private route: ActivatedRoute,
    private routerService: RouterService,
    private websocketService: WebsocketService,
    private auth: AuthService,
    private sharedService: SharedService,
    private cdRef: ChangeDetectorRef,
    private deviceService: DeviceDetectorService
  ) {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.serverUrl = `${environment.WebsocketUrl}`;
    this.authToken = this.auth.getAuthToken() ? this.auth.getAuthToken() : localStorage.getItem('access_token');
    this.websocketSubscription = this.websocketService.connect(this.serverUrl, this.authToken).subscribe(
      (message: MessageEvent) => {
        this.messages.push(message.data);
        console.log(message.data, this._route.url);
      },
      (error) => console.error(error),
      () => console.log('WebSocket connection closed')
    );
    const user_details = localStorage.getItem('user_details');
    if (user_details) {
      localStorage.setItem('isloggedin', 'true');
    } else {
      localStorage.setItem('isloggedin', 'false');
    }
  }

  private openAppOrRedirectToStore(): void {
    // Parse query parameters
    const urlParams = new URLSearchParams(window.location.search);
    const viewInvoice = urlParams.get('viewInvoice') === 'true';
    const invoiceId = urlParams.get('invoiceId');
      console.log('Query params:', { viewInvoice, invoiceId });

      const isMobile = this.deviceService.isMobile();
      const os = this.deviceInfo.os?.toLowerCase();
      const ua = navigator.userAgent.toLowerCase();
      const isAndroid = os === 'android' || ua.includes('android');
      const isIOS = os === 'ios' || ua.includes('iphone') || ua.includes('ipad');

      // Desktop: Redirect to /invoices/all-invoice if query params present, else stay
      if (!isMobile) {
        if (viewInvoice && invoiceId) {
          console.log('Desktop: Redirecting to:', this.DESKTOP_REDIRECT);
          this._route.navigate([this.DESKTOP_REDIRECT]);
        } else {
          console.log('Desktop: Staying on web (no query params)');
        }
        return;
      }

      // Unknown platform: Redirect or stay
      if (!isAndroid && !isIOS) {
        if (viewInvoice && invoiceId) {
          console.log('Unknown platform: Redirecting to:', this.DESKTOP_REDIRECT);
          this._route.navigate([this.DESKTOP_REDIRECT]);
        } else {
          console.log('Unknown platform: Staying on web');
        }
        return;
      }

      const fallback = () => {
        console.log('Falling back to store:', isAndroid ? this.PLAY_STORE_URL : this.APP_STORE_URL);
        window.location.href = isAndroid ? this.PLAY_STORE_URL : this.APP_STORE_URL;
      };

      // Track if page loses focus (indicates app opened)
      let hasBlurred = false;
      const handleBlur = () => {
        hasBlurred = true;
        window.removeEventListener('blur', handleBlur);
      };
      window.addEventListener('blur', handleBlur);

      // Track if page is still visible
      let isPageVisible = true;
      const handleVisibilityChange = () => {
        isPageVisible = document.visibilityState === 'visible';
      };
      document.addEventListener('visibilitychange', handleVisibilityChange);

      // Build deep link: Use PendingScreenDetails if query params present, else default
      const deepLinkPath = viewInvoice && invoiceId ? `PendingScreenDetails/${invoiceId}` : '';
      const deepLinkUrl = deepLinkPath ? `${this.DEEP_LINK_SCHEME}${deepLinkPath}` : this.DEEP_LINK_SCHEME;

      if (isAndroid) {
        console.log('Attempting Android deep link:', deepLinkUrl);
        const intentUrl = deepLinkPath
          ? `intent://${deepLinkPath}#Intent;scheme=myapp;package=ems.portal;end`
          : `intent://#Intent;scheme=myapp;package=ems.portal;end`;
        window.location.href = intentUrl;
      } else if (isIOS) {
        console.log('Attempting iOS deep link:', deepLinkUrl);
        window.location.href = deepLinkUrl;
      }

      // Fallback after 3 seconds if page is still visible and no blur
      setTimeout(() => {
        if (isPageVisible && !hasBlurred) {
          console.log('Deep link failed, redirecting to store');
          fallback();
        } else {
          console.log('Deep link succeeded, app opened');
        }
        window.removeEventListener('blur', handleBlur);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
      }, 3000);
  }

  ngOnInit(): void {
    this.loaderSubscription = this.sharedService.loaderState$.subscribe((state: any) => {
      this.showLoader = state;
      this.cdRef.markForCheck();
    });
    this.loaderSubscription1 = this.sharedService.loaderState1$.subscribe((state: any) => {
      this.showLoader1 = state;
      this.cdRef.markForCheck();
    });
    this.routerService.ActivateRouteService();
    this.openAppOrRedirectToStore();
  }

  ngOnDestroy(): void {
    if (this.websocketSubscription) {
      this.websocketSubscription.unsubscribe();
    }
    this.websocketService.close();
  }

  sendMessage(message: string): void {
    this.websocketService.send(message);
  }

  ngAfterViewInit() {
    feather.replace();
  }
}